module.exports = __webpack_public_path__ + "img/lock-01.9032fea7.svg";